// extracted by mini-css-extract-plugin
export default {"navigation":"Layout_navigation__towJz","list":"Layout_list__9LNUy","logo":"Layout_logo__2eoNe","action":"Layout_action__rw-zY","active":"Layout_active__9sKlC"};